import { render, staticRenderFns } from "./Socinal.vue?vue&type=template&id=264a7875&"
import script from "./Socinal.vue?vue&type=script&lang=js&"
export * from "./Socinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports